import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IShopState, SHOP_KEY } from '../models/shop.model';

const selectFeature = createFeatureSelector<IShopState>(SHOP_KEY);

export const selectCurrentShop = createSelector(selectFeature, (state: IShopState) => state.shop);

export const selectCurrentShopDirector = createSelector(selectFeature, (state: IShopState) =>
  state.shop ? state.shop.director : null,
);

export const selectLoadingStateOfShop = createSelector(
  selectFeature,
  (state: IShopState) => state.isLoading,
);

export const selectShopDataListIsLoading = createSelector(
  selectFeature,
  (state: IShopState) => state.isShopDataListLoading,
);

export const selectIsAllShopDataFetched = createSelector(
  selectFeature,
  (state: IShopState) => state.allShopDataFetched,
);

export const selectCurrentShopsList = createSelector(
  selectFeature,
  (state: IShopState) => state.shopList,
);

export const selectShopPhotoReportList = createSelector(
  selectFeature,
  (state: IShopState) => state.shopPhotoReportList,
);
